'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SameAsOtherPax = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class;

var _reactRedux = require('react-redux');

var _pacomo = require('utils/pacomo');

var _forms = require('utils/forms');

var _reactIntl = require('react-intl');

var _utilityFunctions = require('utils/utilityFunctions');

var _selectors = require('selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    SameAsOtherPax: {
        displayName: 'SameAsOtherPax'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/Users/gareth.chou/Documents/GAdventures/g-rex/app/components/forms/SameAsOtherPax.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var flightOverrideCodes = ['ARRIVAL_PRE_THREE_WEEKS', 'DEPARTURE_POST_THREE_WEEKS', 'PREVIOUS_TOUR_IN_CITY'];

var flightRequirements = ['ARRIVAL_FLIGHT_DETAILS', 'DEPARTURE_FLIGHT_DETAILS'];

var SameAsOtherPax = exports.SameAsOtherPax = _wrapComponent('SameAsOtherPax')((0, _pacomo.pacomoDecorator)(_class = function (_Component) {
    (0, _inherits3.default)(SameAsOtherPax, _Component);

    function SameAsOtherPax(props) {
        (0, _classCallCheck3.default)(this, SameAsOtherPax);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SameAsOtherPax.__proto__ || (0, _getPrototypeOf2.default)(SameAsOtherPax)).call(this, props));

        _this.getResourceHrefs = function () {
            var requirements = _this.props.requirements;

            var resourceHrefs = {};

            if (requirements.length) {
                requirements.forEach(function (requirement) {
                    var departureService = _this.props.departureServicesById[requirement.services[0].id];
                    var tourId = departureService.product.id;
                    resourceHrefs[tourId] = resourceHrefs[tourId] || {};

                    var overrideValuePath = (0, _forms.generateValuePath)({
                        resourceType: 'overrides',
                        requirement: requirement
                    });
                    var valuePath = (0, _forms.generateValuePath)({
                        resourceType: 'flight_statuses',
                        requirement: requirement
                    });

                    resourceHrefs[tourId][requirement.code] = {
                        overrides: overrideValuePath,
                        flight_statuses: valuePath,
                        uniqueFlightId: requirement.customer + '-' + requirement.code + '-' + requirement.services[0].id
                    };
                });
            }

            return resourceHrefs;
        };

        _this.getValues = function (paxId) {
            var flightReqSets = _this.props.flightReqSets;

            var arrivals = flightReqSets[paxId].FLIGHT_INFORMATION.reqsByCode.ARRIVAL_FLIGHT_DETAILS || [];
            var departures = flightReqSets[paxId].FLIGHT_INFORMATION.reqsByCode.DEPARTURE_FLIGHT_DETAILS || [];
            var flights = arrivals.concat(departures).sort(function (a, b) {
                var aDepService = _this.props.departureServicesById[a.services[0].id];
                var bDepService = _this.props.departureServicesById[b.services[0].id];
                if (aDepService.id === bDepService.id) {
                    // if same departure_service, order arrival before departure
                    return a.code === 'ARRIVAL_FLIGHT_DETAILS' ? -1 : 1;
                } else {
                    return aDepService.start_date < bDepService.start_date ? -1 : 1;
                }
            });
            var values = {};
            flights.map(function (flight) {
                if (flight.status === 'COMPLETE') {
                    var departureService = _this.props.departureServicesById[flight.services[0].id];
                    var tourId = departureService.product.id;
                    values[tourId] = values[tourId] || {};

                    if (flight.applied_overrides.length) {
                        values[tourId][flight.code] = {
                            resourceType: 'overrides',
                            resourceValue: flight.fieldValuesByResourceType.overrides
                        };
                    } else {
                        values[tourId][flight.code] = {
                            resourceType: 'flight_statuses',
                            resourceValue: flight.fieldValuesByResourceType.flight_statuses.segments.value
                        };
                    }
                }
            });
            return values;
        };

        _this.processCopy = function (paxId) {
            var _this$props = _this.props,
                array = _this$props.array,
                change = _this$props.change,
                initialValues = _this$props.initialValues;


            var resourceHrefs = _this.getResourceHrefs();
            var values = _this.getValues(paxId);

            var visibleFlights = _this.props.flightDetailsIsVisible || [];
            var flightFlights = _this.props.isFlights || [];

            (0, _keys2.default)(values).forEach(function (serviceId) {
                flightRequirements.forEach(function (code) {
                    var value = values[serviceId][code];
                    var resourceHref = resourceHrefs[serviceId][code];

                    if (value && resourceHref) {
                        var uniqueFlightId = resourceHref.uniqueFlightId;

                        switch (value.resourceType) {
                            case 'overrides':
                                // Tidy up segments before we apply the override
                                var initialVal = (0, _utilityFunctions.getResourceValue)(resourceHref.flight_statuses + '.segments', initialValues);
                                array.removeAll(resourceHref.flight_statuses + '.segments');
                                initialVal.forEach(function (segment) {
                                    array.push(resourceHref.flight_statuses + '.segments', segment);
                                });
                                change(resourceHref.overrides + '.reason.code', value.resourceValue.reason.code);

                                // Remove this flight from visible flights (because it has an override)
                                if (visibleFlights.includes(uniqueFlightId)) {
                                    visibleFlights = visibleFlights.filter(function (flightId) {
                                        return flightId !== uniqueFlightId;
                                    });
                                }

                                // Determine if override is flight/not
                                if (!flightOverrideCodes.includes(value.resourceValue.reason.code)) {
                                    if (flightFlights.includes(uniqueFlightId)) {
                                        flightFlights = flightFlights.filter(function (flightId) {
                                            return flightId !== uniqueFlightId;
                                        });
                                    }
                                } else {
                                    if (!flightFlights.includes(uniqueFlightId)) {
                                        flightFlights = [].concat((0, _toConsumableArray3.default)(flightFlights), [uniqueFlightId]);
                                    }
                                }
                                break;
                            case 'flight_statuses':
                                array.removeAll(resourceHref.flight_statuses + '.segments');
                                value.resourceValue.map(function (newItem) {
                                    return array.push(resourceHref.flight_statuses + '.segments', newItem);
                                });

                                // Reset the requirement's override value
                                change(resourceHref.overrides + '.reason.code', '');

                                // Add this flight to visible flights (because it does not have an override)
                                if (!visibleFlights.includes(uniqueFlightId)) {
                                    visibleFlights = [].concat((0, _toConsumableArray3.default)(visibleFlights), [uniqueFlightId]);
                                }
                                if (!flightFlights.includes(uniqueFlightId)) {
                                    flightFlights = [].concat((0, _toConsumableArray3.default)(flightFlights), [uniqueFlightId]);
                                }
                            default:
                                break;
                        }
                    }
                });
            });

            _this.props.setFlightDetailsIsVisible(visibleFlights);
            _this.props.setIsFlights(flightFlights);
        };

        _this.renderForm = function () {
            var input = void 0;
            var paxIds = (0, _keys2.default)(_this.props.flightReqSets).filter(function (id) {
                return id != _this.props.paxId;
            });
            var items = paxIds.map(function (paxId, i) {
                var name = _this.props.customersById[paxId].name;

                return _react3.default.createElement(
                    'option',
                    { key: i, value: paxId },
                    name.legal_first_name,
                    ' ',
                    name.legal_last_name
                );
            });
            if (paxIds.length) {
                var helpText = _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'SameAsOtherPax.render.helpText',
                    defaultMessage: 'If your flight details are the same as someone else\'s, you can copy them by clicking the button above. Note: You will still need to click Save to submit the form.'
                });
                return _react3.default.createElement(
                    'div',
                    { className: 'wrapper' },
                    _react3.default.createElement(
                        'form',
                        { onSubmit: function onSubmit(e) {
                                e.preventDefault();
                                if (input && input.value) {
                                    _this.processCopy(input.value);

                                    clearTimeout(_this.copiedTimeoutId);
                                    _this.setState({ isRecentlyCopied: true });
                                    _this.copiedTimeoutId = setTimeout(function () {
                                        _this.setState({ isRecentlyCopied: false });
                                    }, 3000);
                                }
                            } },
                        _react3.default.createElement(
                            'select',
                            { ref: function ref(node) {
                                    input = node;
                                } },
                            items
                        ),
                        _react3.default.createElement(
                            'button',
                            { disabled: _this.state.isRecentlyCopied },
                            _this.state.isRecentlyCopied ? 'Copied!' : 'Copy'
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'helpText' },
                        helpText
                    )
                );
            } // else
            return null;
        };

        _this.state = {
            isRecentlyCopied: false
        };

        _this.getResourceHrefs = _this.getResourceHrefs.bind(_this);
        _this.getValues = _this.getValues.bind(_this);
        _this.processCopy = _this.processCopy.bind(_this);
        _this.renderForm = _this.renderForm.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(SameAsOtherPax, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // remove timers if not yet finished
            clearTimeout(this.copiedTimeoutId);
        }
    }, {
        key: 'render',
        value: function render() {
            var form = this.renderForm();
            return _react3.default.createElement(
                'div',
                null,
                form
            );
        }
    }]);
    return SameAsOtherPax;
}(_react2.Component)) || _class);

var mapStateToProps = function mapStateToProps(state) {
    return {
        customersById: (0, _selectors.getCustomersById)(state)
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SameAsOtherPax);


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/SameAsOtherPax.js
// module id = 1347
// module chunks = 0